import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { grey } from "designSystem/styles/color";
import { ButtonEnum } from "designSystem/types/button-types";
import CentricIcon from "designSystem/components/icon/CentricIcon";
import { Box, Button, FlexColumn, FlexRowCenter, FormField, Placeholder, PopupDialog, Text, TextField } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useHiggSetupStore } from "./HiggSetupStore";
import HiggIcon from "./icon/HiggIcon";
import InitializeHigg from "./InitializeHigg";

const SetupHiggPlaceholder: FunctionComponent = () => {
	const { onOpenApiDialog } = useHiggSetupStore();

	return (
		<Box
			centerContent
			height={1}
		>
			<Placeholder
				subtitleProps={{ res: "ConnectToHiggSubtitle" }}
				subtitleWidth={407}
				titleProps={{ res: "ConnectToHigg" }}
			>
				{{
					actions:
						<Button
							design="primary"
							onClick={onOpenApiDialog}
							res="ConnectToHigg"
						/>,
					image:
						<FlexRowCenter
							flexGrow={1}
							justifyContent="space-between"
							maxWidth={164}
						>
							<CentricIcon
								black
								removeFillColor
								style={{ fontSize: 63 }}
							/>
							<FlexColumn justifyContent="center">
								<ArrowForwardIcon style={{ color: grey[300] }} />
								<ArrowBackIcon style={{ color: grey[300] }} />
							</FlexColumn>
							<HiggIcon />
						</FlexRowCenter>,
				}}
			</Placeholder>
		</Box>
	);
};

const PopupMain: FunctionComponent = observer(() => {
	const {
		apiTextInputValue,
		isApiKeyValidationFailed,
		onApiTextInputChange,
	} = useHiggSetupStore();

	const loc = useLocale();

	const errorMessage = isApiKeyValidationFailed ? loc.resource("HiggApiKeyNotValid") : "";

	return (
		<>
			<Text res="EnterHiggAPIKey" />
			<Box my={5}>
				<FormField
					control={(
						<TextField
							autoFocus
							fullWidth
							onChange={onApiTextInputChange}
							value={apiTextInputValue}
						/>
					)}
					fullWidth
					invalidMessage={errorMessage}
					label={(
						<Text
							bold
							res="HiggApiKey"
						/>
					)}
					labelPlacement="start"
					standalone
				/>
			</Box>
		</>
	);
});

export const SetupHigg: FunctionComponent = observer(() => {
	const {
		apiKeyExistsOnNode,
		onConnect,
		isConnectButtonDisabled,
		isDialogOpen,
		isResponseLoading,
		setDialogClosed,
	} = useHiggSetupStore();

	return (
		<>
			{isDialogOpen && (
				<PopupDialog
					onClose={setDialogClosed}
					open={isDialogOpen}
					showClose
					titleRes="SetupConnectionToHiggDatabase"
					width={556}
				>
					{{
						main: (
							<PopupMain />
						),
						buttons: (
							<>
								<Button
									design="primary"
									disabled={isConnectButtonDisabled}
									onClick={onConnect}
									res="Connect"
								/>
								<Button
									design="link"
									disabled={isResponseLoading}
									onClick={setDialogClosed}
									res={ButtonEnum.BUTTON_CANCEL}
								/>
							</>
						),
					}}
				</PopupDialog>
			)}
			{apiKeyExistsOnNode ?
				<InitializeHigg />
				:
				<SetupHiggPlaceholder />
			}
		</>
	);
});